import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/authContext";
import { makeAuthenticatedRequest } from "../utils/apiRequest";

const LocationPopup = ({ token, onClose, onAdd }) => {
//   const [locations, setLocations] = useState([]);  // Store all locations fetched from the API
//   const [searchQuery, setSearchQuery] = useState(""); // Store the search query input by the user
//   const [filteredLocations, setFilteredLocations] = useState([]); // Store the filtered locations based on search
//   const [selectedLocations, setSelectedLocations] = useState([]); // Store the selected locations (displayed as chips)
//   const [arrangement, setArrangement] = useState("Company Arrangement"); // Default arrangement for selected locations
 

  const { locations, token: authToken } = useAuth(); // Get locations and token from AuthContext
const [searchQuery, setSearchQuery] = useState("");
const [filteredLocations, setFilteredLocations] = useState(locations || []);
const [selectedLocations, setSelectedLocations] = useState([]);
const [arrangement, setArrangement] = useState("Company Arrangement");
const [taxPercentage, setTaxPercentage] = useState(0);


useEffect(() => {
    console.log("Locations from AuthContext:", locations);
  }, [locations]);

  // Fetch tax percentage from API
  useEffect(() => {
    const fetchTaxPercentage = async () => {
      try {
        const response = await makeAuthenticatedRequest(
          "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_taxes",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch tax data.");

        const data = await response.json();
        // Extract tax percentage from the first tax entry in the data array
        if (data && data.data && data.data.length > 0) {
          const taxData = data.data[0];
          if (taxData && taxData.tax_percentage) {
            const taxValue = parseFloat(taxData.tax_percentage);
            setTaxPercentage(taxValue);
            console.log("Tax Percentage:", taxValue);
          }
        }
      } catch (error) {
        console.error("Error fetching tax percentage:", error.message);
      }
    };

    fetchTaxPercentage();
  }, [authToken]);
  


  // Fetch all locations when the popup is opened
//   useEffect(() => {
//     const fetchLocations = async () => {
//       try {
//         const response = await makeAuthenticatedRequest(
//           "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_all_locations",
//           {
//             method: "POST",
//             headers: {
//               "Authorization": `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Failed to fetch locations");
//         }

//         const data = await response.json();
//         setLocations(data.data || []); // Store all fetched locations
//         setFilteredLocations(data.data || []); // Initially, show all locations (can be changed to empty array if you want to hide initially)
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching locations:", error.message);
//         setLoading(false);
//       }
//     };

//     fetchLocations();
//   }, [token]); // Re-fetch locations when the token changes


useEffect(() => {
    setFilteredLocations(locations || []);
  }, [locations]);
  

  // Handle search query change
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    // Filter locations based on the search query
    if (query === "") {
      setFilteredLocations([]); // Hide results if query is empty
    } else {
        setFilteredLocations(
            locations.filter((location) =>
              location.location_name.toLowerCase().includes(query.toLowerCase())
            )
          );
          
    }
  };

  // Helper function to check if tickets are available for a location
const checkTicketAvailability = (ticketsPrice) => {
  let ticketAvailable = false;
  
  // Check if either adults or children tickets are available
  for (const category in ticketsPrice) {
    const { adults, children } = ticketsPrice[category] || {};
    if ((adults && adults.trim() !== "") || (children && children.trim() !== "")) {
      ticketAvailable = true;
      break;
    }
  }
  
  return ticketAvailable;
};


  // Helper function to determine if tax is available for a location
  const checkTaxAvailability = (location) => {
    // Check if location has tax-related properties
    return location.hasOwnProperty('taxAvailable') 
      ? location.taxAvailable 
      : location.hasOwnProperty('taxDetails') || 
        location.hasOwnProperty('tax_info') || 
        (location.tax_percentage && location.tax_percentage > 0) || 
        location.hasOwnProperty('taxable');
  };

  // Handle adding a location as a chip
  const handleAddLocation = (locationName) => {
    if (!selectedLocations.some((location) => location.location_name === locationName)) {
      const location = locations.find((loc) => loc.location_name === locationName);
      
      // Check ticket availability
      const ticketAvailable = checkTicketAvailability(location.tickets_price);
      
      // Check tax availability
      const taxAvailable = checkTaxAvailability(location);
      
      // Extract tax details if available
      const taxDetails = location.taxDetails || [];
      
      // Get tax percentage from taxDetails if available, otherwise use the fetched general tax percentage
      const locationTaxPercentage = taxDetails[0]?.tax_percentage || taxPercentage;
      
      // Print ticket and tax availability in the console
      console.log(`${location.location_name} ticket availability:`, ticketAvailable);
      console.log(`${location.location_name} tax availability:`, taxAvailable);
      console.log(`${location.location_name} tax details:`, taxDetails);
      
      setSelectedLocations([
        ...selectedLocations,
        {
          location_name: location.location_name,
          location_id: location.location_id,
          arrangement: arrangement,
          description: location.description,
          location_img_path: location.location_img_path || [],
          tickets_price: location.tickets_price || {},  // Pass tickets_price here
          ticketAvailability: ticketAvailable, // Add ticket availability flag
          taxAvailable: taxAvailable, // Add tax availability flag
          taxDetails: taxDetails, // Include specific tax details from the API
          tax_percentage: locationTaxPercentage, // Use specific tax percentage if available
          activity_type: "sightseeing", // Add activity type to match SightseeingPopup format
        },
      ]);
    }
  };
  

  // Handle removing a location chip
  const handleRemoveLocation = (locationName) => {
    setSelectedLocations(selectedLocations.filter((item) => item.location_name !== locationName));
  };

  // Handle saving the selected locations with arrangement
  const handleSave = () => {
    if (selectedLocations.length === 0) {
      alert("Please select at least one location.");
      return;
    }
  
    // Pass selected locations with arrangement to the parent
    onAdd(selectedLocations);
    onClose(); // Close the popup after adding
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-1/2 max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Add Location</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-black">
            ✖
          </button>
        </div>

        {/* Search Bar */}
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search for a location..."
          className="w-full p-2 border border-gray-300 rounded mb-4"
        />

        {/* Display loading state */}
        
      
        <div className="space-y-2 max-h-48 overflow-y-auto "> {/* Added max height and scroll */}
  {/* Display filtered locations after user starts typing */}
  {filteredLocations.length > 0 && searchQuery && (
    <div className="space-y-2">
      {filteredLocations.map((location) => (
        <button
          key={location.location_id}
          onClick={() => handleAddLocation(location.location_name)}
          className="w-full p-2 text-left border border-gray-300 rounded mb-2"
        >
          {location.location_name}
        </button>
      ))}
    </div>
  )}

  {/* Display message when no matching locations are found */}
  {searchQuery && filteredLocations.length === 0 && (
    <div>No locations found matching "{searchQuery}"</div>
  )}
</div>

        

        {/* Display Selected Locations as Chips with Arrangement */}
        {selectedLocations.length > 0 && (
         <div className="mt-4">
         <h3 className="text-sm font-semibold text-gray-600">Selected Locations:</h3>
         <div className="flex flex-wrap gap-2 mt-2">
           {selectedLocations.map((location, index) => (
             <div key={index} className="inline-flex items-center bg-blue-500 text-white px-3 py-1 rounded-full">
               <span>{location.location_name}</span>
               <button
                 onClick={() => handleRemoveLocation(location.location_name)}
                 className="ml-2 text-white"
               >
                 ✖
               </button>
             </div>
           ))}
         </div>
       </div>
       
        )}

        {/* Save Button */}
        <div className="mt-4 flex justify-center">
  <button
    onClick={handleSave}
    className="bg-blue-600 text-white px-4 py-2 rounded w-full mt-8"
  >
    Add Location
  </button>
</div>

      </div>
    </div>
  );
};

export default LocationPopup;
